/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ The picture chosen in step 1, held until there is somewhere to put it.    │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **AN UPLOAD NEEDS A WORKSPACE, AND AN INVITED ADMIN HAS NONE UNTIL STEP 2.** Every upload is
 * workspace-scoped (`x-workspace-id`), and `0202` creates the admin's first workspace only when
 * step 2 is submitted. Step 1 is on the invitation page and step 2 on the setup screen — two route
 * elements, with a session reload between them — so the file waits here, in the module, and the
 * setup screen takes it once the workspace exists. A colleague's invitation has a workspace the
 * moment it is accepted, and the invitation page uploads it there and then.
 *
 * ⚠️ **It does not survive a page reload**, and that is accepted: the picture is optional, and the
 * account screen takes one any time.
 */
let held: File | null = null;

export const pendingAvatar = {
  hold(file: File | null): void {
    held = file;
  },
  peek(): File | null {
    return held;
  },
  /** Hands the file over once, so a second upload cannot happen. */
  take(): File | null {
    const file = held;
    held = null;
    return file;
  },
};
